import instance,{ get,post } from "../ajax";

interface savrProductType {
    id: number,
    productName: string,
    productImg: string,
    productDesc: string,
    parvalue: number,
    status: number,
    channelAppId: number,
    channelProductId: string,
    productType: string
}

interface changeStatusProductType {
    productId: number,
    status: number
}
export async function productList(body:Record<string, any>){
    const url = `/api/Product/GetProductPageList?ProductName=${body.ProductName}&Status=${body.Status}&PageIndex=${body.PageIndex}&PageSize=${body.PageSize}`
    const res = await get(url)
    return res;
}

export async function selectProductList(productName?:string){
    const arg = productName ? `?productName=${productName}` : ''
    const url = `/api/SupplyProduct/GetSelectProductList${arg}`
    const res = await get(url)
    return res;
}

export async function appList(){
    const url = `/api/Product/GetChannelAppList`
    const res = await get(url)
    return res;
}

export async function upload(File:FormData){
    const url = `/api/Common/UploadFile`
    const res = await instance.post(url,File)
    return res;
}

export async function saveProduct(body:savrProductType){
    const url = `/api/Product/SaveProduct`
    const res = await post(url,body)
    return res;
}

export async function changeStatusProduct(body:changeStatusProductType){
    const url = `/api/Product/SaveProductStatus`
    const res = await post(url,body)
    return res;
}

export async function allProductList(PageIndex:number,PageSize:number,grade:string,productName?:string){
    const url = `/api/Product/GetSelectProductList?ProductName=${productName}&PageIndex=${PageIndex}&PageSize=${PageSize}&Grade=${grade}`
    const res = await get(url)
    return res;
}

export async function importTemplate(){
    const url = `/api/Product/GetImportTemplate`
    const res = await get(url)
    return res;
}

export async function importProduct(File:FormData){
    const url = `/api/Product/ImportProduct`
    const res = await instance.post(url,File)
    return res;
}